import { Media, MediaKind, MediaTransformationKind, Nullable, Ref, takeId } from "shared";
import { API_BASE_URL } from "../config";
import { Icon, ICON_AUDIO, ICON_DOCUMENT, ICON_MEDIA, ICON_VIDEO } from "../../icons";

export function mediaUrl(media: Ref<Media>, kind: MediaTransformationKind): string;
export function mediaUrl(media: Nullable<Ref<Media>>, kind: MediaTransformationKind): string | undefined;
export function mediaUrl(media: Nullable<Ref<Media>>, kind: MediaTransformationKind): string | undefined {
	if (media == null) return undefined;
	return `${API_BASE_URL}/media/${takeId(media)}/${kind}`;
}

export async function urlToFile(
	url: string,
	{ title, contentType }: { title?: string; contentType?: string } = {}
): Promise<File> {
	let response = await fetch(url);
	let data = await response.blob();

	// Get file extension from content type (eg. "svg" from "image/svg+xml" and "png" from "image/png")
	const fileExtension = response.headers.get("content-type")?.split("/")?.[1]?.split("+")?.[0];
	const fileName = title ?? `file${fileExtension != null ? `.${fileExtension}` : ""}`;
	return new File([data], fileName, {
		type: contentType ?? response.headers.get("content-type") ?? undefined
	});
}

export function mediaKindToIcon(kind: MediaKind): Icon {
	switch (kind) {
		case MediaKind.IMAGE:
			return ICON_MEDIA;
		case MediaKind.VIDEO:
			return ICON_VIDEO;
		case MediaKind.AUDIO:
			return ICON_AUDIO;
		case MediaKind.DOCUMENT:
		default:
			return ICON_DOCUMENT;
	}
}
